import * as GQL from "src/types/graphql";
import { FormEngineRuleFormData, RuleType } from "./schemas";

export type MultiSelectItem = {
  id: string;
  label: string;
};

export interface TagType {
  id: string;
  name: string;
  tag_group?: {
    name: string;
  } | null;
}

export interface School {
  id: string;
  name: string;
}
export const resolveRuleType = (
  values: FormEngineRuleFormData
): GQL.form_engine_rule_type_enum | null => {
  switch (values.configuration_type) {
    case "AUTO_WAITLIST":
      return RuleType.AUTO_WAITLIST;
    case "AUTO_PLACEMENT":
      return RuleType.AUTO_PLACEMENT;
    case "DYNAMIC_SIBLING":
      return RuleType.DYNAMIC_SIBLING_TAG;
    case "FORM_QUESTION":
      return values.rule_type ?? null;
    default:
      return null;
  }
};
const buildRuleConfig = (
  values: FormEngineRuleFormData,
  ruleType: GQL.form_engine_rule_type_enum
): Record<string, unknown> => {
  const rule_name = values.rule_name;
  const rule_description = values.rule_description || undefined;

  switch (ruleType) {
    case RuleType.AUTO_WAITLIST:
      return {
        rule_name,
        rule_description,
        source_statuses: values.source_statuses,
        school_ids: values.school_ids,
        enable_automatic_offers: values.enable_automatic_offers,
      };
    case RuleType.AUTO_PLACEMENT:
      return {
        rule_name,
        rule_description,
        school_ids: values.school_ids,
        tag_ids: values.tag_ids,
        source_statuses: values.source_statuses,
      };
    case RuleType.DYNAMIC_SIBLING_TAG:
      return {
        rule_name,
        rule_description,
        tag_ids: values.tag_ids,
        enable_remove_tag: values.enable_remove_tag,
        school_ids: values.school_ids,
        status: values.status,
      };
    case RuleType.QUESTION_TAG:
      return {
        rule_name,
        rule_description,
        tag_ids: values.tag_ids,
        enable_remove_tag: values.enable_remove_tag,
        question_id: values.question_id ?? "",
        answer_option_ids: values.answer_option_ids,
        school_ids: values.school_ids,
      };
    case RuleType.GEOGRAPHIC_PREFERENCE_TAG:
      return {
        rule_name,
        rule_description,
        tag_ids: values.tag_ids,
        enable_remove_tag: values.enable_remove_tag,
        question_id: values.question_id ?? "",
        is_inside: values.inside_outside
          ? values.inside_outside === "inside"
          : null,
        boundary_type: values.boundary_type,
        boundary_ids: values.boundary_ids,
        ...(values.school_ids.length > 0
          ? { school_ids: values.school_ids }
          : {}),
      };
    default:
      return { rule_name, rule_description };
  }
};

export const buildRulePayload = (
  values: FormEngineRuleFormData
): {
  rule_type: GQL.form_engine_rule_type_enum;
  rule_config: string;
  key: string;
} | null => {
  const rule_type = resolveRuleType(values);
  if (!rule_type) {
    return null;
  }

  return {
    rule_type,
    rule_config: JSON.stringify(buildRuleConfig(values, rule_type)),
    key: values.rule_key,
  };
};
